import ApiResourceManager from '../ApiResourceManager';

// What the agent posted in a chat on its own (A15), like an import's result: eve can't add a message to a session from
// a server route, so the agent keeps them as notices on the chat (GET /chats/{id}: { chat, events, notices }, contracts
// §6). On the agent itself (VITE_PLATFORM_AGENT_URL): use with useApiClient({ baseUrl:
// import.meta.env.VITE_PLATFORM_AGENT_URL, autoLogOut: false }) and the headers the panel's chat sends the agent
// (platformAgentHeaders), so the agent sees the same person and restaurant as in the chat.
export default class PlatformAgentNoticesManager extends ApiResourceManager {
  get = (chatId, headers = {}) =>
    this.request({
      method: 'GET',
      url: `/chats/${encodeURIComponent(chatId)}`,
      headers,
    });
}
